import "../styles/footerContainer.css"
import FooterComponent from "../components/footer-components/FooterComponent";

const Footer = () => {
    return (
        <>
            <FooterComponent />
        </>
    )
}

export default Footer;